import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ValueStackSection } from './components/ValueStackSection';
import { BonusBox } from './components/BonusBox';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen font-sans text-body bg-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <ValueStackSection data-id="element-5" />
        <BonusBox data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <StickyMobileCTA data-id="element-12" />
    </div>;
}